export default function mCEP(cep) {
  cep = cep.replace(/\D/g, '');
  cep = cep.replace(/^(\d{5})/, '$1');
  cep = cep.replace(/^(\d{5})(\d{3}).*/, '$1-$2');
  return cep;
}
